import apiResultInspector from "./apiResult/apiResult";
import chunkLoadErrorInspector from "./chunkLoad/chunkLoad";
import { noAccessErrorInspector } from "./noAccess";
import requestError from "./requestError";
import resourceLoadingErrorInspector from "./resourceLoading";
import urlInspector from "./url/url";
export const registry = [
    apiResultInspector,
    urlInspector,
    chunkLoadErrorInspector,
    requestError,
    resourceLoadingErrorInspector,
    noAccessErrorInspector,
];
export default registry;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVnaXN0cnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9FcnJvckJvdW5kYXJ5L3JlbmRlcmluZy9pbnNwZWN0b3JzL3JlZ2lzdHJ5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sa0JBQWtCLE1BQU0sdUJBQXVCLENBQUM7QUFDdkQsT0FBTyx1QkFBdUIsTUFBTSx1QkFBdUIsQ0FBQztBQUM1RCxPQUFPLEVBQUUsc0JBQXNCLEVBQUUsTUFBTSxZQUFZLENBQUM7QUFDcEQsT0FBTyxZQUFZLE1BQU0sZ0JBQWdCLENBQUM7QUFDMUMsT0FBTyw2QkFBNkIsTUFBTSxtQkFBbUIsQ0FBQztBQUM5RCxPQUFPLFlBQVksTUFBTSxXQUFXLENBQUM7QUFFckMsTUFBTSxDQUFDLE1BQU0sUUFBUSxHQUFHO0lBQ3RCLGtCQUFrQjtJQUNsQixZQUFZO0lBQ1osdUJBQXVCO0lBQ3ZCLFlBQVk7SUFDWiw2QkFBNkI7SUFDN0Isc0JBQXNCO0NBQ3ZCLENBQUM7QUFFRixlQUFlLFFBQVEsQ0FBQyJ9